export default "__VITE_ASSET__Dq7$lNwu__"